<template>
  <v-data-table
    v-if="headers && items"
    ref="table"
    :headers="headers"
    :items="items"
    :mobile-breakpoint="0"
    class="invoice-print-table payflow-table payflow-invoice-table"
    :items-per-page="8000000000000"
    hide-default-footer
  >
    <template v-slot:item.unit="{ item }">
      {{ item.product && item.product.unit ? item.product.unit.fame : "" }}
    </template>
    <template v-slot:item.product="{ item }">
      <span class="payflow-cell-product">{{ item.product.name }}</span>
    </template>
    <template v-slot:item.count="{ item }">
      {{ $numberFormat(parseFloat(item.count)) }}
    </template>
    <template v-slot:item.fee="{ item }">
      {{ $numberFormat(parseFloat(item.fee)) }}
    </template>
    <template v-slot:item.row="{ item }">
      {{ parseInt(items.indexOf(item)) + 1 }}
    </template>
    <template v-slot:item.tax="{ item }">
      {{ $numberFormat(parseFloat(item.tax)) }}
    </template>
    <template v-slot:item.discount="{ item }">
      <span v-if="parseFloat(item.discount) > 0" class="payflow-discount-text">
        {{ $numberFormat(parseFloat(item.discount)) }}
      </span>
      <span v-else>—</span>
    </template>
    <template v-slot:item.sum="{ item }">
      {{
        $numberFormat(
          parseFloat(item.fee * item.count) +
            parseFloat(item.tax) -
            parseFloat(item.discount)
        )
      }}
    </template>
    <template v-slot:body.append>
      <tr class="payflow-tfoot-row">
        <td colspan="6" class="payflow-tfoot-label">{{ $t("sum") }}</td>
        <td colspan="2" class="payflow-tfoot-value">
          {{ $numberFormat(totals.fee) }} {{ currencyName }}
        </td>
      </tr>
      <tr class="payflow-tfoot-row">
        <td colspan="6" class="payflow-tfoot-label">
          {{ $t("tax") }}
          <span v-if="taxPercent > 0">({{ taxPercent }}٪)</span>
        </td>
        <td colspan="2" class="payflow-tfoot-value">
          {{ $numberFormat(totals.tax) }} {{ currencyName }}
        </td>
      </tr>
      <tr v-if="totalDiscount > 0" class="payflow-tfoot-row">
        <td colspan="6" class="payflow-tfoot-label">{{ $t("discount") }}</td>
        <td colspan="2" class="payflow-tfoot-value payflow-discount-text">
          {{ $numberFormat(totalDiscount) }}- {{ currencyName }}
        </td>
      </tr>
      <tr class="payflow-tfoot-row payflow-tfoot-row--total">
        <td colspan="6" class="payflow-tfoot-label payflow-tfoot-label--bold">
          {{ $t("amountForPay") }}
        </td>
        <td colspan="2" class="payflow-tfoot-value payflow-tfoot-value--total">
          {{ $numberFormat(grandTotal) }} {{ currencyName }}
        </td>
      </tr>
      <tr v-if="content" class="invoice-content-row">
        <td colspan="8">
          <span class="invoice-content-label">{{ $t("content") }}:</span>
          {{ content }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "PayFlowPrintTable",
  props: {
    headers: { type: Array, default: null },
    items: { type: Array, default: () => [] },
    content: { type: String, default: null },
    currencyName: { type: String, default: "" },
    totals: { type: Object, required: true },
    totalDiscount: { type: Number, default: 0 },
  },
  computed: {
    grandTotal() {
      return this.totals.fee - this.totalDiscount + this.totals.tax;
    },
    taxPercent() {
      if (!this.totals.fee || this.totals.fee <= 0) return 0;
      return Math.round((this.totals.tax / this.totals.fee) * 100);
    },
  },
};
</script>
